import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import ModalFrame from '../../common/_ModalFrame.jsx';
import InfoDrawer from '../../common/_InfoDrawer.jsx';
import ZoomModal from '../../modals/_ZoomModal.jsx';
import HelpCenterHeader from '../support/_HelpCenterHeader.jsx';

import CrowdNavigation from '../common/_CrowdNavigation.jsx';
import CrowdfundingHeaderClock 	from '../common/_CrowdfundingHeaderClock.jsx';
import WebinarVideo 	from '../common/_WebinarVideo.jsx';

import GuidelinesContent from './guidelinescontent/GuidelinesContent.jsx';

export default class CrowdGuidelines extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.seriesList = blapp.models.get('listSeries');

		this.state = {
			series: blapp.models.get('listSeries'),
			hasMounted: false,
			clickedImage: false,
			guidelines: GuidelinesContent()[blapp.util.getUrlVar('guideline')] ? GuidelinesContent(this.seriesList)[parseInt(blapp.util.getUrlVar('guideline')) - 1] : GuidelinesContent(this.seriesList)[GuidelinesContent().length - 1],
			selectedGuidelines: blapp.util.getUrlVar('guideline') ? parseInt(blapp.util.getUrlVar('guideline')) - 1 : GuidelinesContent()[GuidelinesContent().length - 1].id,
			showUpdates: true,
		};
	}

	componentDidMount() {
		const guidelineImages = document.querySelectorAll('.crowd-guidelines-image');

		Array.from(guidelineImages).map(item => {
			if(!item.classList.contains('crowd-guidelines-image--no-zoom')) {
				item.addEventListener('click', (img) => {
					const imageUrl = item.querySelector('img').src;
					this.toggleZoomModal(imageUrl);
				});
			}
		});

		if(window.location.hash == '#studio') {
			this.openDrawer(0, 1);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevState.selectedGuidelines != this.state.selectedGuidelines) {
			this.setState({guidelines: GuidelinesContent(this.state.series)[this.state.selectedGuidelines]})
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.state.clickedImage ? <ZoomModal data={{images: [this.state.clickedImage]}} func={{toggleZoomModal: () => this.toggleZoomModal(false)}}/> : null}
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={2}/> : null}
				<HelpCenterHeader title="Submission Guidelines"/>
				<CrowdfundingHeaderClock series={this.state.series}/>
				<div className="main">
					<div className="main__content">
						{this.renderIntro()}
						{this.renderContent()}
						{this.renderFooter()}
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderIntro() {
		return (
			<section className="crowd-faq__intro">
				<h1 className="text--xxl-title text--bold l-margin-bottom--xl text-color--darkestBlue">Set your baseplate up for success</h1>
				<div className="notification notification--warning l-flex text-color--darkestBlue l-margin-bottom--xl l-pad-x--xl">
					<i className="fas fa-exclamation-circle notification__icon l-margin-right l-margin-top--sm text--title"/>
					<p className="text--bold">To ensure the best possible start on your digital submission for the BrickLink Designer Program (BDP), please review our guidelines carefully.</p>
				</div>
				<p className="l-margin-bottom">The following rules are here to make sure models pass through the governing processes of BDP smoothly. We’re not trying to stifle creativity or limit your ability to do excellent work. In past programs, we’ve had challenges getting fan designs approved for model safety, stability, and building experience. So we have developed these guidelines to prevent the kinds of issues we have seen going forward.</p>
				<p>Also, please note that we do not aim to reject submissions for minor issues. The submission period exists to help us review and work with Fan Designers to correct any issues that we find. Please do not hesitate to submit your model with the fear that we will reject your model.</p>
			</section>
		);
	}

	renderContent() {
		const guidelines = this.state.guidelines.content.map((guideline, key) => {
			const parentId = guideline.id;

			return (
				<section id={guideline.title.toLowerCase().replace(/ /g, '-')} className={key != 0 ? 'crowd-help__faq-group' : ''}>
					<header className="l-flex l-split l-margin-bottom" id={guideline.title.replace(' ', '-').toLowerCase()}>
						<h2 className="text--xl-title text--bold">{guideline.title}</h2>
						<button data-ts-name={`faq-expand-collapse-all faq-expand-collapse-all--${guideline.title}`} className="btn btn--link" onClick={() => this.expandContentSection(guideline.id)}>{guideline.allOpen ? 'Collapse' : 'Expand'} all</button>
					</header>
					{guideline.intro ? <p className="crowd-help__faq-group-intro">{guideline.intro}</p> : null}
					{guideline.items.map((item, key) => <InfoDrawer id={item.urlHash ? item.urlHash : item.question.replace(/ /g, '-').replace('?', '').toLowerCase()} isOpen={item.open} onChangeFunc={() => this.openDrawer(parentId, item.id)} classes="crowd-help__faq-item" key={key} label={item.question} icon={'arrow'} bold={true}><p className="l-margin-top--sm" dangerouslySetInnerHTML={{__html: item.answer}}/></InfoDrawer>)}
				</section>
			);
		});

		return (
			<section className="crowd-help__faq-section crowd-guidelines__faq-section base-formating">
				{GuidelinesContent().length ?
					<div className="crowd-guidelines__version-select">
						<select className="select l-margin-bottom" value={this.state.selectedGuidelines} onChange={(e) => this.changeSelectedGuideline(e.target.value)}>
							{GuidelinesContent().reverse().map(item => <option value={item.id}>{item.title}</option>)}
						</select>
					</div>
				: null}
				<WebinarVideo source={'guidelines'} classes="l-margin-bottom--xl l-margin-top" seriesNum={this.state.guidelines.seriesNum}/>
				{this.renderUpdates()}
				{guidelines}
			</section>
		);
	}

	expandContentSection(id) {
		const {guidelines} = this.state;
		const groupID = guidelines.content.findIndex(item => item.id == id);

		if(guidelines.content[groupID].allOpen == true) {
			guidelines.content[groupID].allOpen = false;

			guidelines.content[groupID].items.map(item => item.open = false);
		}else{
			guidelines.content[groupID].allOpen = true;

			guidelines.content[groupID].items.map(item => item.open = true);
		}

		this.setState({guidelines: guidelines});
	}

	openDrawer(parentId, itemId) {
		const {guidelines} = this.state;
		const parentIdx = guidelines.content.findIndex(item => item.id == parentId);
		const itemIdx = guidelines.content[parentIdx].items.findIndex(item => item.id == itemId);

		guidelines.content[parentIdx].items[itemIdx].open = !guidelines.content[parentIdx].items[itemIdx].open;

		const isAllOpen = guidelines.content[parentIdx].items.filter(item => item.open == true).length == guidelines.content[parentIdx].items.length;

		if(isAllOpen) {
			guidelines.content[parentIdx].allOpen = true;
		}else{
			guidelines.content[parentIdx].allOpen = false;
		}

		this.setState({guidelines: guidelines});
	}

	renderFooter() {
		return (
			<section className="crowd-faq__footer">
				<h2 className="text--xl-title text--bold l-margin-bottom--xl">Get more information</h2>
				<div className="crowd-faq__footer-content crowd-faq__footer-content--extra">
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--red">
							<i className="fa-light fa-fw fa-info-circle"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Have questions about the program?</p>
							<a href={blapp.url2.getCrowdProjectFAQUrl()} className="text--bold crowd-faq__footer-item-cta">Explore FAQs</a>
						</div>
					</div>
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--blue">
							<i className="fa-light fa-fw fa-messages-question"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Still need help? Discuss various topics with the community and BDP team.</p>
							<a href={"https://forum.bricklink.com/viewforum.php?f=13&sid=275872312bdb877b1372a3ec3a8d56d7"} className="text--bold crowd-faq__footer-item-cta">Visit the Forum</a>
						</div>
					</div>
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--yellow">
							<i className="fa-light fa-fw fa-lightbulb-on"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Want to freshen up on your Studio skills or troubleshoot?</p>
							<a href={"https://studiohelp.bricklink.com/hc/en-us"} target="_blank" className="text--bold crowd-faq__footer-item-cta">Tour Studio Help Center<i className="l-margin-left--sm far fa-square-arrow-up-right"/></a>
						</div>
					</div>
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--green">
							<i className="fa-light fa-fw fa-envelope"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Need feedback or have specific questions about your design?</p>
							<a href={"mailto:bdpsupport@lego.com"} className="text--bold crowd-faq__footer-item-cta">Email the BDP Team</a>
						</div>
					</div>
				</div>
			</section>
		);
	}

	renderUpdates() {
		const {guidelines} = this.state;

		if(guidelines.updates) {
			const updateTitle = guidelines.updateTitle;
	
			return (
				<section className="notification notification--success text-color--darkestBlue l-margin-bottom l-margin-top l-pad--xl l-pad-top--l notification--no-break">
					<div className="l-flex l-split">
						<h2 className="text--xl-title text--bold l-margin--null text--break-word"><i className="fas fa-stars l-margin-right"/>{updateTitle}</h2>
						<button className="btn btn--link l-flex l-center text--no-wrap" onClick={() => this.setState({showUpdates: !this.state.showUpdates})}>{this.state.showUpdates ? 'Hide' : 'Show'}<i className={`fas fa-chevron-${this.state.showUpdates ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					{this.state.showUpdates && <div className="l-margin-top" dangerouslySetInnerHTML={{__html: guidelines.updates}}/>}
				</section>
			);
		}
	}

	toggleZoomModal(url) {
		this.setState({clickedImage: url}, blapp.screen.toggleScroll(!this.state.clickedImage));
	}

	changeSelectedGuideline(val) {
		this.setState({selectedGuidelines: val});

		const newURL = blapp.util.addParamToUrl('guideline', parseInt(val) + 1, window.location);
		history.pushState('', '', newURL);
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CrowdGuidelines blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-crowd' )
						);
		blapp.refs.register( "main", elem );
	}
);
